/*
 * @Author: Teemo Ding
 * @Date: 2021-07-07 16:24:56
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 14:59:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Order/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { getOrder, saveOrder } from '@/src/request/settings/order';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import OrderIdFormat from './OrderIdFormat';
import UnpaidOrderCancellation from './UnpaidOrderCancellation';
import { breadcrumbData } from './config';

const permissions = () => {
  const view_order_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsOrder,
        operation: EnumOperation.view_order_setting,
      }),
    ],
  });
  const edit_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsOrder,
        operation: EnumOperation.edit_setting,
      }),
    ],
  });
  return {
    view_order_setting,
    edit_setting,
  };
};
const Order = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_order_setting, edit_setting } = permissions();
  const [form] = Form.useForm();
  const history = useHistory();
  const [hasModified, setHasModified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, serOrder] = useState({} as any);

  useEffect(() => {
    if (view_order_setting) {
      getOrder().then((data) => {
        serOrder(data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const onValuesChange = (changedValues, allValues) => {
    setHasModified(true);
  };

  const onFinish = (values) => {
    saveOrder(values).then(() => message.success('Save success!'));
    setHasModified(false);
  };

  const Child = [
    {
      child: view_order_setting ? (
        <UnpaidOrderCancellation
          disabled={!edit_setting}
          listPaymentReminders={order?.listPaymentReminders}
        />
      ) : null,
    },
    {
      child: view_order_setting ? (
        <OrderIdFormat disabled={!edit_setting} />
      ) : null,
    },
  ];

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };
  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified}
    />
  );

  return (
    <Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText='Leave'
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.leave_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />

      <Skeleton loading={loading} active>
        <Form
          initialValues={{
            ...order,
            numberFormat: 'consecutive',
            timeUnit: order?.timeUnit || 'RollingDays',
            idGenerationPolicy: order?.idGenerationPolicy ?? 'Consecutive',
          }}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          hideRequiredMark
          form={form}
          name='store_details'
          scrollToFirstError>
          <Layout
            elements={Child}
            topLeft={topLeft}
            topRight={topRight}></Layout>
        </Form>
      </Skeleton>
    </Fragment>
  );
};

export default Order;
